import React, { useEffect, useState } from 'react';
import './styles.sass'

export interface Props {
    promos: {
        image: string;
        url: string;
    }[];
};

/**
 * A component to render up to 3 promo sections
 */
const PromoSection = ({ promos }: Props) => {
    if (promos.length === 0) {
        return null;
    }

    return (
        <div className='mv-promo-section'>
            {promos.filter(p => p.url && p.url.length > 0 && p.image && p.image.length > 0)
            .map(promo => {
                return (
                    <button
                        className='promo'
                        style={{
                            background: `url('${promo.image}')`
                        }}
                        onClick={() => window.open(promo.url, '_blank')}
                    />
                );
            })}
        </div>
    );
};

export {
    PromoSection,
};
